import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { Link } from 'react-router-dom';
import media from '../../styles/config/mediaQueries';

const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  margin-bottom: 6px;
  border-radius: 20px;
  background-color: ${rgba(theme.color.black200, 0.7)};
  line-height: 15px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  ${typeStyle['font-10-semi-bold']};
  ${media.mobile`
    padding: 2px 13px;
  `}
  ${media.desktop`
    padding: 3px 10px;
  `}
`;

const StyledCircle = styled.span`
  display: inline-block;
  width: 4px;
  height: 4px;
  margin-right: 5px;
  background-color: ${props => theme.color[props.color]};
  border-radius: 50%;
`;

export { StyledLink, StyledCircle };
